import { Helmet } from "react-helmet-async";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  { q: "Where does Kratoven kratom come from?", a: "All our kratom is hand-harvested from mature trees in the Kalimantan (Borneo) rainforest by multi-generational farming families, then finished and packed in our Indonesian facility." },
  { q: "Is every batch lab-tested?", a: "Yes. Every batch is independently tested for alkaloid profile, heavy metals, and microbial contaminants. Certificates of Analysis are available on request." },
  { q: "What does the 45-day guarantee cover?", a: "If you aren't satisfied with your purchase for any reason within 45 days of delivery, contact us for a full refund — even if the pouch is opened." },
  { q: "How fast does shipping take?", a: "All orders ship from Borneo via DHL Express. Typical transit: 3–5 business days to the US/Canada, 4–7 business days to Europe, 2–4 business days within Asia." },
  { q: "Do you ship internationally?", a: "Yes — worldwide via DHL Express. We do NOT ship to Indonesia (domestic restriction), Australia, Denmark, Finland, Israel, Japan, Malaysia, Myanmar, New Zealand, Poland, Romania, Russia, Singapore, South Korea, Sweden, Thailand, United Kingdom, Vietnam, or the restricted US states listed on our Shipping page." },
  { q: "How is shipping calculated?", a: "All orders ship worldwide via DHL Express from our facility in Borneo. Shipping is calculated at checkout based on your destination and the total billable weight of your order. We do not offer free shipping — DHL Express rates apply on every order." },
  { q: "Are duties and taxes included?", a: "No. Your total covers products + DHL Express shipping only. Import duties, VAT, and any local taxes are the recipient's responsibility and are collected by customs on arrival." },
  { q: "How is Kratoven packaged?", a: "Each order is sealed in our signature matte-black resealable foil pouches — vacuum-flushed for freshness and completely discreet. Shipping is fully unmarked." },
  { q: "What payment methods do you accept?", a: "Stripe (credit/debit card), PayPal (coming soon), and direct bank transfer for larger orders." },
  { q: "Can I track my order?", a: "Yes. You'll receive DHL Express tracking as soon as your order ships. You can also view order status in your account dashboard." },
];

export default function FAQ() {
  return (
    <>
    <Helmet>
      <title>FAQ | Kratoven</title>
      <meta
        name="description"
        content="Frequently asked questions about Kratoven products, DHL shipping, payments, guarantees, lab testing, and order tracking."
      />
      <link rel="canonical" href="https://kratoven.com/faq" />
    </Helmet>
    <div className="container-kv pt-32 pb-20 max-w-3xl" data-testid="faq-page">
      <div className="overline mb-4">Frequently Asked</div>
      <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mb-10">Questions, answered.</h1>
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border border-white/5 px-5 bg-[#0D120E]" data-testid={`faq-${i}`}>
            <AccordionTrigger className="text-left font-serif text-lg hover:no-underline hover:text-[#C8A97E]">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#A8A5A1] leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
    </>
  );
}
